<template>
	<div>

    <div class="p-grid">

      <div v-for="(guide,index) in structure" :key="name + '_' + index" :class="['p-pt-1 p-pb-1', 'p-col-12',{'p-md-6' : guide.type!='absorptions'}, {'hidden': guide.hidden}]" >

        <SimpleText v-if="guide.mode==='simple' && guide.type==='text'" 
          :section="name" :guide="guide" :data="data" 
          :overview="true"/>

        <SimpleCalendar v-if="guide.mode==='simple' && guide.type==='calendar'" 
          :section="name" :guide="guide" :data="data" 
          :overview="true"/>

        <SimpleNumber v-if="guide.mode==='simple' && guide.type==='number'" 
          :section="name" :guide="guide" :data="data" 
          :overview="true"/>
        
        <SimpleSelect v-if="guide.mode==='simple' && guide.type==='select'" 
          :section="name" :guide="guide" :data="data" :domains="domains"
          :overview="true"/>
        
        <SimpleCheck v-if="guide.mode==='simple' && guide.type==='check'" 
          :section="name" :guide="guide" :data="data"
          :overview="true"/>
        
        <SimpleRadio v-if="guide.mode==='simple' && guide.type==='radio'" 
          :section="name" :guide="guide" :data="data"
          :overview="true"/>
        
        <ComplexColumn v-if="guide.mode==='complex' && guide.type==='column'" 
          :section="name" :guide="guide" :data="data"
          :overview="true"/>
        
        <ComplexTimeslots v-if="guide.mode==='complex' && guide.type==='timeslots'" 
          :section="name" :guide="guide" :data="data"
          :overview="true"/>
          
        <ComplexAbsorptions v-if="guide.mode==='complex' && guide.type==='absorptions'" 
          :section="name" :guide="guide" :data="data"
          :overview="true"/>
          
        <ComplexDelta v-if="guide.mode==='complex' && guide.type==='delta'" 
          :section="name" :guide="guide" :data="data"
          :overview="true"/>

        <StaticImage v-if="guide.mode==='static' && guide.type.startsWith('image_')" 
          :section="name" :guide="guide" :extras="extras"
          :overview="true"/>
          
        <StaticLink v-if="guide.mode==='static' && guide.type==='link'" 
          :section="name" :guide="guide"
          :overview="true"/>

      </div>

    </div>

    <!-- <pre>{{ JSON.stringify(data,null,2) }}</pre> -->

  </div>

</template>

<script>
import SimpleText from './simple/Text';
import SimpleCalendar from './simple/Calendar';
import SimpleNumber from './simple/Number';
import SimpleSelect from './simple/Select';
import SimpleCheck from './simple/Check';
import SimpleRadio from './simple/Radio';
import ComplexColumn from './complex/Column';
import ComplexTimeslots from './complex/Timeslots';
import ComplexAbsorptions from './complex/Absorptions';
import ComplexDelta from './complex/Delta';
import StaticImage from './static/Image';
import StaticLink from './static/Link';

export default {
  components: {
    SimpleText,
    SimpleCalendar,
    SimpleNumber,
    SimpleSelect,
    SimpleCheck,
    SimpleRadio,
    ComplexColumn,
    ComplexTimeslots,
    ComplexAbsorptions,
    ComplexDelta,
    StaticImage,
    StaticLink,
  },
  props: {
      structure: Object,
      data: Object,
      name: String,
      domains: Object,
      extras: Object,
    },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>